'use client';

import React from 'react';
import { SplitButton } from 'primereact/splitbutton';
import { Link } from 'react-router-dom';

export default function ActionMenu({ 
    data, 
    actions = [], 
    className = "" 
}) {
    const menuItems = actions.map((action, index) => {
        if (action.separator) return { separator: true };

        const customClass = action.className || '';

        return {
            label: action.label,
            icon: action.icon,
            className: customClass,
            // 1. Move the command logic here. PrimeReact handles the click for us.
            command: () => {
                if (action.command) action.command(data);
            },
            template: (item, options) => {
                const content = (
                    <div className={`p-menuitem-link ${options.className}`} style={{ cursor: 'pointer' }}>
                        <span className={`${options.iconClassName} mr-2 ${customClass}`}></span>
                        <span className={`${options.labelClassName} ${customClass}`}>{item.label}</span>
                    </div>
                );

                // 2. If it's a Link, wrap the content. 
                // Note: command will still trigger if defined, but Link handles navigation.
                if (action.to) {
                    const targetPath = typeof action.to === 'function' ? action.to(data) : action.to;
                    return (
                        <Link to={targetPath} className="no-underline">
                            {content}
                        </Link>
                    );
                }

                // 3. For buttons, just return the content. 
                // PrimeReact wraps this in a clickable <li> that triggers the 'command'.
                return content;
            }
        };
    });

    return (
        <SplitButton 
            model={menuItems}
            severity="secondary" 
            size="small"
            text 
            dropdownIcon="fas fa-ellipsis-v"
            className={`p-0 border-none shadow-none ${className}`} 
            buttonProps={{ 
                style: { display: 'none' } 
            }}
            menuButtonProps={{ 
                className: 'border-none shadow-none p-2',
                style: { borderRadius: '4px', border: 'none' }
            }}
        />
    );
}